import { render, staticRenderFns } from "./PwaInstallPrompt.vue?vue&type=template&id=70f26532&scoped=true"
import script from "./PwaInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PwaInstallPrompt.vue?vue&type=script&lang=js"
import style0 from "./PwaInstallPrompt.vue?vue&type=style&index=0&id=70f26532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f26532",
  null
  
)

export default component.exports